import React from 'react';

import find from 'lodash/find';

import {DetailPageGenericPoliciesSidebar} from 'app/components/general/DetailPageGenericPoliciesSidebar';
import {
  useAttachPolicyToProcedure,
  useDetachPolicyFromProcedure,
} from 'app/policies/api';
import {
  convertLocationParamsToFetchParams,
  useProcedures,
} from 'app/procedures/api';
import {UNLIMITED_PAGE_SIZE} from 'app/utils/constants';

import type {DetailPolicySerializedType} from 'sweet-types';

type Props = {
  policy: DetailPolicySerializedType;
};
export function PolicyProceduresSidebar({policy}: Props) {
  const {data} = useProcedures({
    policy_id: policy.id,
    fields: [
      'name',
      'url',
      'id',
      'html_url',
      'edited_at',
      'created_at',
      'can_edit',
      'current_version',
      'policies',
    ],
    ordering: 'name',
    page_size: UNLIMITED_PAGE_SIZE.toString(),
  });
  const [attachPolicyToProcedure] = useAttachPolicyToProcedure();
  const [detachPolicyFromProcedure] = useDetachPolicyFromProcedure();
  return (
    <DetailPageGenericPoliciesSidebar
      attachedItems={data?.results || []}
      closeUrl={policy.html_url}
      detailPageObjectId={policy.id}
      detailPageContentType={'policy'}
      sidebarContentType={'procedure'}
      showFilterField={policy.can_edit}
      canEdit={policy.can_edit}
      useDataHook={useProcedures}
      onAttach={(item) => {
        return attachPolicyToProcedure({
          genericLinks: [
            {
              policy: policy.url,
              procedure: item.url,
            },
          ],
        });
      }}
      onRemove={(item) => {
        const linkedDocument = find(item.policies, {
          url: policy.url,
        });
        if (linkedDocument != null) {
          return detachPolicyFromProcedure(linkedDocument.link_url);
        }
        throw 'Linked document not found';
      }}
      paramsConverter={convertLocationParamsToFetchParams}
    />
  );
}
